module.exports = __webpack_public_path__ + "img/data-empty.85987dc8.gif";